export const STYLED_AVATAR_INITIALS_FONT_SIZE_PX = 16;
export const STYLED_AVATAR_BORDER_WIDTH_PX = 0;
export const STYLED_AVATAR_OUTLINE_WIDTH_PX = 0;
